<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="140px">
            <el-form-item label="设备类型：" prop="device_type">
                <el-select clearable v-model="model.device_type" disabled placeholder="请选择" style="width: 150px">
                    <el-option v-for="item in enuObj('device_type')" :key="'device_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="设备编号：" prop="device_code">
                <el-input v-model="model.device_code" disabled></el-input>
            </el-form-item>
            <el-form-item label="通道号：" prop="channel_no" v-if="device_type==2">
                <el-select clearable v-model="model.channel_no" placeholder="请选择" style="width: 150px">
                    <el-option v-for="item in enuObj('channel_no')" :key="'channel_no'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="设备状态：" prop="cancel_type">
                <el-select clearable v-model="model.cancel_type" placeholder="请选择" style="width: 150px">
                    <el-option v-for="item in enuObj('device_cancel_type')" :key="'device_cancel_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
                <el-input type="textarea" :rows="4" v-model="model.remark"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
            <el-button @click="closeDialog" size="medium">取 消</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'deviceAlert',
    mixins: [editutil],
    props: {
        device_id: {
            type: Number,
            default() {
                return -1;
            }
        },
        device_type: {
            type: Number,
            default() {
                return -1;
            }
        },
        device_code: {
            type: String,
            default() {
                return '';
            }
        }
    },
    data() {
        return {
            model: {
                device_type: '',
                device_id: '',
                device_code: '',
                channel_no: '1',
                remark: '',
                cancel_time: '',
                cancel_user_id: '',
                cancel_user_name: '',
                cancel_type: '1',
            },
            getObj:{
                url:'/api/admin/deviceextract/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['channel_no', 'device_type', 'device_cancel_type'],
            rules: {
                channel_no: [
                    {required: true, message: '通道号不能为空', trigger: 'blur'},
                ],
                cancel_type: [
                    {required: true, message: '设备状态不能为空', trigger: 'blur'},
                ],
            },
            checkObj:{
                url:'/api/admin/deviceextract/check',
                data:{}
            },
            exits_p_name:'code',
            exits_p_title:'设备编号',
        };
    },
    methods: {
        getModelData() {
            this.model = this.copyObj(this.init_model);
            this.model.device_id = this.device_id
            this.model.device_code = this.device_code
            this.model.device_type = this.device_type+""
        },
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/alertcancellog/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
    }
};
</script>